var map = {
	"./403-image.png": 6095,
	"./Aditional-icon-PDF.svg": 3815,
	"./Aditional-icon-Word.svg": 5855,
	"./Aditional-icon-digital.svg": 7969,
	"./Aditional-icon-web.svg": 1283,
	"./Aditional-icon-youtube.svg": 3506,
	"./GenialSkills-logo-small.png": 2947,
	"./GenialSkills-logo.png": 7945,
	"./HomeMenu-icon-Home.svg": 5425,
	"./HomeMenu-icon-Homework.svg": 6474,
	"./HomeMenu-icon-Kinder-GS.svg": 8810,
	"./HomeMenu-icon-Lessons.svg": 8859,
	"./HomeMenu-icon-Library.svg": 4173,
	"./HomeMenu-icon-Message.svg": 1649,
	"./HomeMenu-icon-Progress.svg": 2205,
	"./Lesson-aditional-icon.svg": 8965,
	"./Lesson-chat.svg": 4026,
	"./Lesson-download-icon.svg": 3210,
	"./Lesson-forum-icon.svg": 1487,
	"./LessonBellasArtes-icon.svg": 9583,
	"./LessonDefault-icon.svg": 8820,
	"./LessonEducacionFisica-icon.svg": 9229,
	"./LessonEnglish-icon.svg": 4973,
	"./LessonMath-icon.svg": 4673,
	"./LessonMenu-icon-back.svg": 9856,
	"./LessonMenu-icon-challenge.svg": 808,
	"./LessonMenu-icon-concept.svg": 1355,
	"./LessonMenu-icon-examples.svg": 7780,
	"./LessonMenu-icon-finish.svg": 688,
	"./LessonMenu-icon-practice.svg": 4250,
	"./LessonMenu-icon-vocabulary.svg": 1149,
	"./LessonSalud-icon.svg": 1812,
	"./LessonScience-icon.svg": 8635,
	"./LessonSocialStudies-icon.svg": 73,
	"./LessonSpanish-icon.svg": 8109,
	"./Logo-SJ-estudia-avanza.svg": 7448,
	"./Menu-icon-teams.svg": 9473,
	"./Offline-icon.svg": 2870,
	"./TopBarMenu-icon-help.svg": 3644,
	"./TopBarMenu-icon-language.svg": 5003,
	"./UserComp-bg.jpg": 3379,
	"./UserComp-bg.png": 7115,
	"./UserComp-icon-dashboard.svg": 3488,
	"./UserComp-icon-logout.svg": 8078,
	"./UserComp-icon-message.svg": 1241,
	"./UserComp-icon-notification.svg": 7249,
	"./UserComp-icon-profile.svg": 9235,
	"./background-chat.jpg": 1384,
	"./bg-login.jpg": 1834,
	"./bg-offline.jpg": 2632,
	"./bg-offline.png": 3612,
	"./bg.jpg": 5150,
	"./generic-cover-library.jpg": 6208,
	"./icon-Microsoft.svg": 4891,
	"./icon-congratulations-homework.png": 8811,
	"./icon-congratulations.png": 4138,
	"./icon-file-csv.jpg": 4762,
	"./icon-file-doc.jpg": 5456,
	"./icon-file-jpg.jpg": 5075,
	"./icon-file-mp3.jpg": 5164,
	"./icon-file-pdf.jpg": 1600,
	"./icon-file-xlm.jpg": 7559,
	"./icon-institucional.svg": 651,
	"./icon-no-book.jpg": 2554,
	"./icon-suscribe.svg": 2375,
	"./icon-teacher.svg": 709,
	"./image-modal-timesOut.svg": 605,
	"./lesson-mark.svg": 339,
	"./logo-GS-APP.png": 6461,
	"./logo-GenialSkills.svg": 6901,
	"./logo-SJ-APP.png": 1028,
	"./logo-genials-big.svg": 355,
	"./logo_gs_game.png": 1292,
	"./mantenimiento.png": 7737,
	"./sample-avatar.png": 575,
	"./signin.svg": 2197,
	"./user-menu-icon.svg": 4908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;